import type React from 'react';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { Blank } from '@src/library/components/common';
import type { Note as Notemodel } from 'library/models/clients';
import { useLoadNotes } from './model';
import * as st from './styles.module.scss';

type Props = {
  id: number;
  children?: (note: Notemodel) => JSX.Element;
  searchNotes: string;
};

export const NoteList: React.FC<Props> = ({ id, children, searchNotes }) => {
  const { loading, notes, hasNextPage, loadMore } = useLoadNotes({ search_text: searchNotes }, id);

  return (
    <InfinityList className={st.notes} loading={loading} hasMore={hasNextPage} loadMore={loadMore}>
      {notes.map((note) => (children ? children(note) : <></>))}
      {!loading && !notes.length && <Blank text="Здесь пока нет заметок" />}
    </InfinityList>
  );
};
